module.exports = __webpack_public_path__ + "img/header.bc93528d.png";